import { useContext } from "react"
import { AuthContext, IAuthContextType } from "../services/context/AuthContext"

const useAuth = () => useContext(AuthContext) as IAuthContextType

export default useAuth